var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6 text-sm-h5 text-md-h4 font-weight-bold"},[_vm._t("default"),_c('v-sheet',{class:{ 'mt-1': !_vm.xsOnly },attrs:{"color":"black","width":_vm.width,"height":_vm.height}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }